import { useState } from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, ClipboardList } from 'lucide-react';
import { generalWaMessage } from './servicesData';
import useWhatsApp from '@/lib/useWhatsApp';
import { useLang } from '@/lib/LanguageContext';
import ServiceRequestModal from './ServiceRequestModal';

export default function ServicesCTA({ message = generalWaMessage }) {
  const { waLink, t } = useWhatsApp();
  const es = useLang().language === 'es';
  const [showModal, setShowModal] = useState(false);
  return (
    <section className="relative py-24 px-6 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-background to-background" />
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-100px' }}
        transition={{ duration: 0.8 }}
        className="max-w-3xl mx-auto text-center relative">
        <h2 className="font-inter font-black text-3xl md:text-4xl tracking-[-0.03em] text-foreground mb-4">
          {t('Ready to Build Something Great?')}
        </h2>
        <p className="text-muted-foreground font-inter leading-relaxed mb-10 max-w-xl mx-auto">
          {t('Tell us about your project and our team will get back to you with a tailored plan, no commitment required.')}
        </p>
        <div className="flex flex-wrap items-center justify-center gap-4">
          <a
            href={waLink(message)}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-4 bg-primary text-primary-foreground font-inter font-semibold text-sm tracking-wider uppercase rounded-xl hover:bg-primary/90 transition-all duration-300 hover:shadow-lg hover:shadow-primary/25">
            <MessageCircle className="w-4 h-4" />
            {t('Chat on WhatsApp')}
          </a>
          <button
            onClick={() => setShowModal(true)}
            className="inline-flex items-center gap-2 px-8 py-4 border border-primary/40 text-primary font-inter font-semibold text-sm tracking-wider uppercase rounded-xl hover:bg-primary/10 transition-all duration-300">
            <ClipboardList className="w-4 h-4" />
            {es ? 'Pedido personalizado' : 'Custom Order'}
          </button>
        </div>
      </motion.div>
      {showModal && <ServiceRequestModal onClose={() => setShowModal(false)} />}
    </section>
  );
}